import $ from 'jquery';

$(function () {
  if ($('.primary-nav').length) {
    const $secondaryNav = $('.header__secondary-nav');
    const currentUrl = window.location.href;

    if ($('.current_page_ancestor').length) {
      $('.current_page_ancestor .sub-menu').first().appendTo($secondaryNav);
    } else {
      $('.current_page_item .sub-menu').first().appendTo($secondaryNav);
    }

    // Remove Secondary Nav if it's empty
    if ($secondaryNav.is(':empty')) {
      $('.header__divider')[2].remove();
    }

    // Current Issue Nav Item Modifications
    if ($('.primary-nav__current-issue').length) {
      const $currentIssueLink = $('.primary-nav__current-issue');
      const currentIssueHref = $currentIssueLink.find('a').attr('href');

      if (currentIssueHref === currentUrl) {
        $currentIssueLink.addClass('active');
      }
    }

    if (currentUrl.includes('/events')) {
      $('.header__secondary-nav .sub-menu').append(
        `
        <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-2241">
          <a href="${window.location.origin}/submit-event" class="secondary-nav__submit-event-btn">Submit Your Event</a>
        </li>
        `
      );
    }
  }
});
